// extracted by mini-css-extract-plugin
export default {"addShipping":"Ob-z"};